export default function($) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.querySelector('.jdgm-widget-actions-wrapper')) {
          insertCustomButton();
          observer.disconnect();
        }
      });
    });
  });

  const target = document.getElementById('judgeme_product_reviews');
  if (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  function insertCustomButton() {
    const actionsWrapper = document.querySelector('.jdgm-widget-actions-wrapper');
    if (actionsWrapper && !document.querySelector('.custom-review-button')) {
      const customButton = document.createElement('a');
      customButton.href = '#';
      customButton.className = 'custom-review-button button button-secondary';
      customButton.innerHTML = window.judgemeTrans.askQuestion;
      customButton.target = '_blank';

      actionsWrapper.appendChild(customButton);
    }
  }

};
